import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  Select,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import GroupRemoveIcon from '@mui/icons-material/GroupRemove';
import FileOpenIcon from '@mui/icons-material/FileOpen';

import { Segment_Upload_Mode } from '@occc/graphql';

type SegmentUploadActionModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (mode: Segment_Upload_Mode) => void;
};

const UPLOAD_MODE_OPTIONS = [
  {
    value: Segment_Upload_Mode.Add,
    icon: GroupAddIcon,
    label: 'Add members to the segment',
  },
  {
    value: Segment_Upload_Mode.Remove,
    icon: GroupRemoveIcon,
    label: 'Remove members from the segment',
  },
  {
    value: Segment_Upload_Mode.Overwrite,
    icon: FileOpenIcon,
    label: 'Overwrite the existing segment members',
  },
];

export const SegmentUploadActionModal = ({
  open,
  onClose,
  onConfirm,
}: SegmentUploadActionModalProps) => {
  const [selectedMode, setSelectedMode] = useState<Segment_Upload_Mode>(Segment_Upload_Mode.Add);

  const handleConfirm = () => {
    onConfirm(selectedMode);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
      <DialogTitle>CSV file upload</DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          <Typography variant='body1' color='text.secondary'>
            Choose an option below for your uploaded file
          </Typography>

          <FormControl fullWidth>
            <Select
              value={selectedMode}
              onChange={(e) => setSelectedMode(e.target.value as Segment_Upload_Mode)}
            >
              {UPLOAD_MODE_OPTIONS.map(({ value, icon: Icon, label }) => (
                <MenuItem key={value} value={value}>
                  <Stack direction='row' alignItems='center' spacing={1}>
                    <ListItemIcon sx={{ minWidth: 'unset' }}>
                      <Icon fontSize='small' sx={{ opacity: 0.3 }} />
                    </ListItemIcon>
                    <ListItemText primary={label} />
                  </Stack>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant='text' size='medium' onClick={onClose}>
          Cancel
        </Button>
        <Button variant='contained' size='medium' onClick={handleConfirm}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
